import {useMemo} from "react";
import useDidMount from "common/hooks/use-did-mount";
import useQueryParams from "common/hooks/use-query-params";
import {toQueryString} from "common/lib/ext/object";
import Survey from "public/components/partials/survey";

export default function OrderSurvey() {
  const queryParams = useQueryParams();
  const benchmarkID = queryParams.get("benchmark_id");
  const orderID = queryParams.get("order_id");
  const packageID = queryParams.get("package_id");
  const redirect = useMemo(() => {
    const query = {};
    if(benchmarkID) { query.benchmark_id = benchmarkID; }
    if(orderID) { query.order_id = orderID; }
    if(packageID) { query.package_id = packageID; }
    const queryString = toQueryString(query);

    return `/order/complete?${queryString}`;
  }, [benchmarkID, orderID, packageID]);

  useDidMount(() => {
    window.google_conversion_id = 965414859;
    window.google_conversion_language = "en";
    window.google_conversion_format = "3";
    window.google_conversion_color = "ffffff";
    window.google_conversion_label = "TnCkCPuw0WMQy5-szAM";
    window.google_remarketing_only = false;
  });

  return (
    <>
      <Survey
        benchmarkID={benchmarkID}
        orderID={orderID}
        packageID={packageID}
        redirect={redirect}
      />
      <script src="//www.googleadservices.com/pagead/conversion.js" type="text/javascript" />
    </>
  );
}
